'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var notify = require('notify');
var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');
var dataMgr = require('./data-mgr');
var sidePanel = require('./side-panel');

var dom;

var onBulkDownloadFormLoaded = function(e, data) {

	sidePanel.open(data.response.markup, {type: 'bulk-download-form'});
	setupDom();
	addPanelEventHandlers();

};

var loadBulkDownloadForm = function(e) {

	e.preventDefault();

	$.ajax({
		type: 'POST',
		dataType: 'JSON',
		url: dataMgr.getEventUrl() + '?page=load_bulk_download_form',
		data: {
		}
	}).done(function(response) {

		triggerCustomEvent(response.status.detail, {
			data: {
				response: response
			}
		});

	});

};

var onGalleryCheckboxChange = function() {

	var totalCnt = 0;

	dom.checkboxes.each(function() {

		if (this.checked) {

			totalCnt += window.parseInt(this.dataset.imgCnt, 10);

		}

	});

	dom.totalCnt.text(totalCnt);

};

var onFormSubmit = function(e) {

	var data = {
		galleries: []
	};

	var $btn = appDom.document.find('.bulk-download-form__submit-btn');


	e.preventDefault();

	$btn.val(window.pbizServer.content.loading);

	dom.checkboxes.each(function() {

		if (this.checked) {

			data.galleries.push(this.dataset.galleryId);

		}

	});

	data.galleries = data.galleries.join(',');

	if (dom.codeInput.length) {

		data.code = dom.codeInput.val().trim();

	}

	$.ajax({
		method: 'POST',
		dataType: 'JSON',
		url: dataMgr.getEventUrl() + '?page=bulk_download_form_action',
		data: data
	}).done(function(response) {

		if (response.status.code) {

			window.location = response.successUrl;

		} else {

			notify.show({
				target: $('[name="' + response.target + '"]'),
				msg: response.status.msg,
				container: '.bulk-download-form',
				closeOnClick: true
			});

			appDom.document.find('.bulk-download-form__submit-btn').val('start download');

		}

	});

};

var setupDom = function() {

	dom = {
		form: $('#bulkDownloadForm')
	};

	dom.checkboxes = dom.form.find('.bulk-download-form__gallery-checkbox');
	dom.totalCnt = dom.form.find('.bulk-download-form__total-cnt');
	dom.codeInput = dom.form.find('.bulk-download-form__code-input');
	dom.submitBtn = dom.form.find('.bulk-download-form__submit-btn');

};

var addPanelEventHandlers = function() {

	appDom.document.one('side_panel_closed', destroy);

	dom.form
		.on('change', '.bulk-download-form__gallery-checkbox', onGalleryCheckboxChange)
		.on('submit', onFormSubmit);

};

var addEventHandlers = function() {

	appDom.document
		.on('click', '.js-load-bulk-download-form', loadBulkDownloadForm)
		.on({
			'load_bulk_download_form': loadBulkDownloadForm,
			'bulk_download_form_loaded': onBulkDownloadFormLoaded
		});

};

var destroy = function() {

	dom = null;

};

var init = function() {

	addEventHandlers();

};

module.exports = {
	init: init
};
